<template>
  <div>
    <div class="relative pt-6 sm:p-6 my-1">
      <div class="flex justify-between items-center">
        <div class="flex flex-col md:flex-row">
          <h1 class="text-xl font-semibold leading-6 text-gray-900">
            Units
          </h1>
          <div class="flex md:px-20 justify-center items-center">
            <InputSwicth
              v-model="toggleArchivedRooms"
              :class="`!before:bg-white-0 !before:dark:bg-white-900`"
            />
            <span
              class="ms-3 pl-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >{{ toggleArchivedRooms ? "Hide" : "Show" }} archived rooms</span
            >
          </div>
        </div>
        <RequiredToSavePublish />
      </div>
      <div
        v-if="v$.getCurrentEditingUnits.$errors.length"
        class="block text-sm error text-error-900"
      >
        <span
          v-for="(error, idx) in v$.getCurrentEditingUnits.$errors"
          :key="idx"
        >
          {{ error.$message }}
        </span>
      </div>
      <div class="mt-8">
        <UnitSection
          :units-props="getCurrentEditingUnits"
          @addUnit="addUnitInternal"
          @deleteUnit="deleteUnitInternal"
          @addUnitRoom="addUnitRoomInternal"
          @deleteUnitRoom="deleteUnitRoomInternal"
          :amenities="amenities"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import useVuelidate from "@vuelidate/core";
import { mapActions, mapGetters } from "vuex";
import InputSwicth from "primevue/inputswitch";
import UnitSection from "../UnitSection/index.vue";
import RequiredToSavePublish from "../RequiredToSavePublish/index.vue";
import { helpers } from "@vuelidate/validators";
import { ACTIVE_STATUS } from "@/constants";

export default {
  name: "UnitsTab",
  components: { UnitSection, RequiredToSavePublish, InputSwicth },
  props: {
    amenities: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      v$: useVuelidate({
        $registerAs: "UnitsTab",
        $lazy: true,
        $autoDirty: true,
      }),
    };
  },
  data() {
    return {
      toggleArchivedRooms: false,
    };
  },
  provide() {
    return {
      toggleArchivedRooms: computed(() => this.toggleArchivedRooms),
    };
  },
  validations: {
    getCurrentEditingUnits: {
      required: helpers.withMessage(
        "One Unit must be active to Publish",
        function () {
          return (
            this.getCurrentHousingStatus !== ACTIVE_STATUS ||
            (this.getCurrentHousingStatus === ACTIVE_STATUS &&
              !!this.getCurrentEditingUnits?.find(
                (unit) =>
                  unit.status === ACTIVE_STATUS &&
                  !!unit?.rooms?.find((room) => room?.status === ACTIVE_STATUS)
              ))
          );
        }
      ),
    },
  },
  computed: {
    ...mapGetters("programManager", [
      "getCurrentHousingType",
      "getGenericListing",
      "getLoading",
      "getCurrentEditingUnits",
      "getCurrentHousingStatus",
    ]),
  },
  methods: {
    addUnitInternal(unit) {
      this.addUnit(unit);
    },
    deleteUnitInternal(unitIndex) {
      this.deleteUnit(unitIndex);
    },
    addUnitRoomInternal(unitIndex, room) {
      this.addUnitRoom({
        unitIndex: unitIndex,
        room: room,
      });
    },
    deleteUnitRoomInternal(unitIndex, roomIndex) {
      this.deleteUnitRoom({ unitIndex, roomIndex });
    },
    ...mapActions("programManager", [
      "addUnit",
      "deleteUnit",
      "addUnitRoom",
      "deleteUnitRoom",
    ]),
  },
};
</script>
